export const SAMPLE_DBML = `Table users {
  id uuid [pk]
  email varchar [unique, not null]
  name varchar
  status UserStatus [default: 'active']
  created_at timestamp [default: \`now()\`]

  Note: 'Application end users.'
}

Table posts {
  id uuid [pk]
  user_id uuid [not null]
  title varchar [not null]
  content text
  created_at timestamp [default: \`now()\`]
}

Table comments {
  id uuid [pk]
  post_id uuid [not null]
  user_id uuid [not null]
  body text [not null]
  created_at timestamp [default: \`now()\`]
}

Enum UserStatus {
  active
  inactive
  banned
}

Ref: posts.user_id > users.id
Ref: comments.post_id > posts.id
Ref: comments.user_id > users.id

TableGroup Authentication {
  users
}

TableGroup Content {
  posts
  comments
}
`;
